import React, { useState, useEffect } from 'react';
import api from "../../../api/api";
import ParentPanel from '../panel/ParentPanel'; 
import "../styles/SeeNotice.css";
import { jwtDecode } from "jwt-decode";

const SeeNotice = () => {
  const [isSidebarCollapsed, setIsSidebarCollapsed] = useState(false);
  const [notices, setNotices] = useState([]);

useEffect(() => {
  const fetchNotices = async () => {
    try {
      const token = localStorage.getItem("token");
      if (!token) return;

      const res = await api.get("/api/notices", {
        headers: { Authorization: `Bearer ${token}` },
      });

      const formatted = res.data.map((notice) => ({
        date: new Date(notice.created_at).toISOString().split('T')[0],
        title: notice.title,
        content: notice.details,
        style: getNoticeStyle(notice.notice_type),
      }));

      setNotices(formatted);
    } catch (err) {
      console.error("❌ Error fetching notices:", err);
    }
  };

  fetchNotices();
}, []);


  // Map notice_type to CSS
  const getNoticeStyle = (type) => {
    switch(type) {
      case "ALL_STUDENTS": return "notice-green";
      case "ALL_TEACHERS": return "notice-yellow";
      case "SELECTED_STUDENTS": return "notice-purple";
      case "SELECTED_TEACHERS": return "notice-pink";
      default: return "notice-blue";
    }
  }

  return (
    <>
      <ParentPanel onToggle={setIsSidebarCollapsed} />

      <div className={`admin-main-content ${isSidebarCollapsed ? 'collapsed' : ''}`}>
        <div className="dashboard-topbar">
          <span className="date-time">TODAY IS {new Date().toLocaleString()}</span>
          <span className="school-name">Semigon Learning ERP</span>
        </div>

        <div className="iphone-frame">
          <div className="iphone-notch"></div>
          <div className="iphone-screen">
            <h1 className="notice-header">📢 Notices</h1>
            <div className="notice-list">
              {notices.map((notice, index) => (
                <div key={index} className={`notice-card ${notice.style}`}>
                  <h3>{notice.title}</h3>
                  <span className="notice-date">{notice.date}</span>
                  <p>{notice.content}</p>
                </div>
              ))}
              {notices.length === 0 && <p style={{ color: '#777' }}>ℹ️ No notices for you</p>}
            </div>
          </div>
          <div className="iphone-home"></div>
        </div>
      </div>
    </>
  );
};

export default SeeNotice;
